import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Re_complete_projectlist() {
    const navigate = useNavigate();
  useEffect(() => {
        navigate('/complete_projects'); 
      }, [navigate]); 
    
      return null; 
}
